/* eslint-disable indent */
import { Box } from '@mui/material';
import MuiList from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import styled from 'styled-components';

import { COLORS, MEDIA } from 'theme';

export const Content = styled(ListItemText)`
  ${({ type, theme }) =>
    type &&
    type === 'note' &&
    `
    .MuiTypography-root {
      font-size: ${theme.fontSize.body1};
      font-weight: ${theme.fontWeight.medium};
    }
  `}

  ${({ $isPreview, $previewLines }) =>
    $isPreview &&
    `
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${$previewLines ?? 4};
    white-space: pre-wrap;
  `}

  .MuiChip-root {
    margin-right: ${({ theme }) => theme.spacing.s2};

    &:last-child {
      margin-right: 0;
    }
  }
  && {
    flex: 1;
  }
`;

export const IconContainer = styled(ListItemIcon)`
  && {
    min-width: unset;
  }

  svg {
    font-size: ${({ theme, type }) =>
      type === 'document' ? theme.fontSize.body1 : '20px'};

    path,
    circle:not(.MuiCircularProgress-circle) {
      fill: ${({ $color }) => $color || COLORS.black50};
      stroke: ${({ $iconStrokeColor }) => $iconStrokeColor || 'transparent'};
    }
  }
`;

export const NoteIconContainer = styled(ListItemIcon)`
  margin-left: ${({ theme }) => theme.spacing.s3};
  svg {
    font-size: ${({ theme }) => theme.fontSize.body1};

    path {
      fill: ${COLORS.kinetikBlue};
    }
  }
`;

export const Item = styled(ListItem)`
  column-gap: ${({ theme }) => theme.spacing.s3};
  flex-wrap: wrap;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: ${({ $inline, theme }) => ($inline ? 0 : theme.spacing.s2)};

    ${({ type }) =>
      type &&
      type === 'note' &&
      `
      margin-bottom: 0;

      .MuiListItemText-root {
        margin-bottom: 0;
        margin-top: 0;
      }
    `}
  }

  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}

  ${({ $inline }) =>
    $inline &&
    `
    && {
      width: auto;
    }
  `}

  ${({ $alignTop }) =>
    $alignTop &&
    `
    && {
      align-items: start;
    }

    ${IconContainer} {
      margin-top: 5px;
    }

    ${Label} {
      margin-top: 8px;
    }
  `}
`;

export const Label = styled.span`
  color: ${({ color }) => color || COLORS.black60};
  font-size: ${({ theme }) => theme.fontSize.h6};
  line-height: ${({ theme }) => theme.lineHeight.h6};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  text-align: right;
  white-space: nowrap;

  ${({ type, theme }) =>
    type &&
    type === 'note' &&
    `
    font-size: ${theme.fontSize.h5};
    font-weight: ${theme.fontWeight.regular};
  `}
`;

export const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSize.body1};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s2};
  margin-left: auto;
`;

export const List = styled(MuiList)`
  &&& {
    padding: ${({ $padding }) => $padding || 0};
  }
`;

export const Time = styled.span`
  font-size: ${({ theme }) => theme.fontSize.h5};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${COLORS.black50};
`;

export const Context = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s2};
  margin-left: auto;
  font-size: ${({ theme }) => theme.fontSize.body1};
  font-weight: ${({ theme }) => theme.fontWeight.medium};

  svg {
    font-size: ${({ theme }) => theme.fontSize.body3};

    path {
      fill: ${COLORS.black30};
    }
  }
`;

export const ActivityType = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s2};
  font-size: ${({ theme }) => theme.fontSize.body1};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  text-transform: capitalize;
  margin-left: ${({ theme }) => theme.spacing.s3};

  svg {
    font-size: ${({ theme }) => theme.fontSize.body1};

    path {
      fill: ${COLORS.green};
    }
  }
`;

export const CardDataGrid = styled(Box)`
  ${MEDIA.desktopSmallUp} {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ theme }) => theme.spacing.xl1};

    &::before {
      position: absolute;
      top: 0;
      left: 50%;
      bottom: 0;
      width: 1px;
      background-color: ${COLORS.black08};
      content: '';
    }
  }
`;

export const ItemContentWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.s1};
`;

export const CardHorizontalLine = styled.div`
  border-bottom: 1px solid ${COLORS.black08};
  margin-bottom: ${({ theme }) => theme.spacing.s2};
`;

export const CardDataElements = styled(Box)`
  display: flex;
  row-gap: ${({ theme }) => theme.spacing.s2};
  flex-wrap: wrap;
`;
